/* ------------------------------------------------------------------
   LOT 24 (08/08/2026) — source carree pour la bande photos clientes.

   sections/lovi-pdp-avis.liquid demande la vignette en
     image_url: width: 288, height: 360, crop: 'center'
   soit un recadrage 4:5 d'un original 1080x1080. lovi-lot24.css affiche
   ensuite la vignette en carre (116x116 mobile / 148x148 desktop) avec
   object-fit:cover : deuxieme recadrage vertical par-dessus le premier.
   Mesure : sur lovi-avis-11 et lovi-avis-03 le flacon sortait du cadre.

   On reecrit height=360 -> height=288 dans le src AVANT que le navigateur
   ne charge l'image (les vignettes sont en loading=lazy et sous la ligne
   de flottaison, donc pas de double requete). 288x288 d'un original
   1080x1080 = l'image entiere, aucun recadrage.

   Ne touche NI le liquid de la section NI aucun autre asset.
   ------------------------------------------------------------------ */
(function () {
  if (window.__loviLot24) return;
  window.__loviLot24 = 1;

  function carre() {
    var imgs = document.querySelectorAll('.lavis-pstrip__img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var s = img.getAttribute('src');
      if (!s || s.indexOf('height=360') === -1) continue;
      img.setAttribute('src', s.replace('height=360', 'height=288'));
      img.setAttribute('width', '288');
      img.setAttribute('height', '288');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', carre);
  } else {
    carre();
  }
})();
